import { ConsumableLifetimeCycleThemeModeConfig } from './types';

const light: ConsumableLifetimeCycleThemeModeConfig = {
  consumableLifetimeCycle: {
    normalButtonBGColor: '#0775bc',
    normalButtonBorderColor: '2px solid #267DAC',
  },
};

export default light;
